"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var UserSourceCodeResource = /** @class */ (function (_super) {
    tslib_1.__extends(UserSourceCodeResource, _super);
    function UserSourceCodeResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserSourceCodeResource.endpoint = '/sourcecodes';
    UserSourceCodeResource.MODEL_NAME = 'usersourcecode';
    return UserSourceCodeResource;
}(base_1.default));
exports.default = UserSourceCodeResource;
//# sourceMappingURL=usersourcecode.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/usersourcecode.js
// module id = HRM6
// module chunks = 0